import React, {useContext,useEffect,useState} from 'react'
import {dataContext,localestr,uid,toText} from '../utils.js'
import EditCtrl from '../cmp/EditCtrl.js'
import CatTablesEdit from './CatTablesEdit'
import Menu from '../cmp/menu'
import icon from '../icons.svg'

function CatHallsEdit({data,actions}){
    const type='catTables'
    let wndData={}
    if(data) wndData=data.wndData
    else wndData=actions.getWndData()
    const setWndData=actions.setWndData
    const tabNew=actions.tabNew
    const tabClose=actions.tabClose
    
    const context=useContext(dataContext)
    const getData=context.getData
    const saveData=context.saveData
    const msg=context.msg
    const loaddata=context.loaddata

    const Data=context.data[type]

    const [currSize, setSize] = useState(10);

    const setValue=(name,data)=>{
        let newData={...wndData}
        if (data==='') newData[name]=null
        else newData[name]=data
        newData.edit=true
        setWndData(newData)
    }

    const setTable=(data)=>{
        let newData={...wndData}
        let newTables=[]
        if (newData.tables!==undefined) newTables=newData.tables.map(el=>({...el,active:false}))
        let idx=-1
        if (data.uid) idx=newTables.findIndex(el=>el.uid===data.uid)
        if (idx===-1){
            newTables.push({...data,uid:uid()})
        } else {
            newTables[idx]={...data}
        }
        newData.tables=newTables
        setWndData(newData)
    }

    const copyTable=()=>{
        if (!wndData.tables) return
        let tbl=undefined
        tbl=wndData.tables.find(el=>el.active===true)
        if (!tbl) return
        tbl={...tbl}
        delete tbl.id
        delete tbl.uid
        tbl.left=parseInt(tbl.left)+20
        if(tbl.left>window.height) tbl.left=window.height-30
        setTable(tbl)
    }

    const delTable=()=>{
        if (!wndData.tables) return
        let tbl=undefined
        tbl=wndData.tables.find(el=>el.active===true)
        if (!tbl) return
        if (!tbl.id){
            let newData={...wndData}
            let newTables=[]
            newTables=newData.tables.filter(el=>el.uid!==tbl.uid)
            newData.tables=newTables
            setWndData(newData)
        } else {
            tbl.marked=tbl.marked==='0'?'1':'0'
            let newData={status:'rem',key:type,data:{id:tbl.id,marked:tbl.marked}}
            saveData(newData,()=>{setTable(tbl)})
        }
    }

    const saveTables=(tbls,owner)=>{
        if (!tbls) {
            tabClose()
            return
        }
        if (!tbls.length) {
            tabClose()
            return
        }
        let newTbls=[...tbls]
        const el=newTbls.pop()
        if (el.edit) {
            const id=el.id || null
            const name=(el.name || '').substring(0,25)
            const left=el.left || 0
            const top=el.top || 0
            const width=el.width || null
            const height=el.height || null
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:type,data:{name,owner,left,top,width,height}}
                saveData(newData,()=>{saveTables(newTbls,owner)})
            }  
            else {
                let newData={status:'mod',key:type,data:{id,name,owner,left,top,width,height}}
                saveData(newData,()=>{saveTables(newTbls,owner)})
            }  
            //let newData={status:'add',key:type,data:{name,fio,code,urHall,urOrder,urDiscount,urReport,urTable,urReject,urFiscal,urAdmin,pass,hall}}
            //saveData(newData,()=>{saveTables(newTbls,oid)})
        } else saveTables(newTbls)
    }

    const saveValue=()=>{
        let errmsg=''
        const name=(wndData.name || '').substring(0,25)
        const goods=wndData.goods || {id:null}
        const newTbls=wndData.tables
        if (name===null || name==='') errmsg=localestr("Не заповнено ім'я")
        if (errmsg!=='') msg(errmsg,localestr('Помилка'),[{caption:'OK',action:()=>{}}])
        else if (wndData.edit){
            let id=wndData.id
            if (id===null || id==='' || id===undefined){
                let newData={status:'add',key:'CatHalls',data:{name,goods}}
                saveData(newData,(d)=>{saveTables(newTbls,d)})
            }  
            else {
                let newData={status:'mod',key:'CatHalls',data:{id,name,goods}}
                saveData(newData,(d)=>{saveTables(newTbls,d)})
            }  
        }
        else saveTables(newTbls,wndData)
    }

    const objHistory=()=>{
        if (!wndData.tables) return
        let tbl=undefined
        tbl=wndData.tables.find(el=>el.active===true)
        if (!tbl) return
        if (!tbl.id) return

        tabNew('repObjHistory',localestr('Історія змін')+' '+toText(tbl['name']),{object:{...tbl,type:type}},true)
    }

    useEffect(() => {
        if (typeof Data === 'undefined') getData(type)
    // eslint-disable-next-line 
    },[Data])

    let content=''

    const setCurHall=(hall)=>{
        //if (hall===undefined) return 
        if (Data===undefined) return 
        let tables=Data.filter(el=>el.owner.id===hall)
        if (wndData.tables) {
            tables=tables.filter(el=>wndData.tables.findIndex(tb=>tb.id===el.id)===-1)
            tables=tables.concat(wndData.tables)
        }
        if (tables!==undefined){
            content=tables.map((el,idx)=>{
                return(<CatTablesEdit key={idx} data={el} size={currSize} actions={setTable}/>)
            })
        }
    }

    const printTables=(scr=false)=>{
        let tables=Data.filter(el=>el.owner.id===wndData.id)
        const prnData={type:5,screen:scr,data:tables}
        loaddata('action=addJobs&data='+JSON.stringify(prnData),undefined,()=>{})
    }

    const prn_req=(act)=>{
        if (wndData.id===undefined) return 
        if (Data===undefined) return 
        msg(localestr('Куди вивести результат?'),localestr('Запитання'),[{caption:localestr('Екран'),action:()=>act(true)},{caption:localestr('Принтер'),action:()=>act()},{caption:localestr('Відмінити'),action:()=>{}}])
    }


    const anyKey=(e)=>{
        let pref=''
        if(e.shiftKey) pref+='shift_'
        if(e.ctrlKey) pref+='ctrl_'
        if(e.altKey) pref+='alt_'
        const key=pref+e.key
        if (document.activeElement.nodeName==='INPUT') return
        if(key==='Delete') delTable()
        else if(key==='Insert') setTable({left:10,top:10,width:50,height:50,name:'',active:true})
        else if(key==='F9') copyTable()
        else if(key==='shift_F4') tabClose()
    }
      
    setCurHall(wndData.id||wndData.uid)

    const menuData=[
        {name:localestr('Друк схеми'),icon:'#prnBut',action:()=>{window.print()}},
        //{name:localestr('Остаточне видалення'),icon:'#remBut',action:clrCatalog},
        {name:localestr('Історія змін'),icon:'#hisBut',action:objHistory},
    ]

    return(

    <div style={{display:'flex',flexDirection:'column', margin:'5px', height:'calc(100% - 10px)'}}>
        <div style={{margin:'2px 0',display:'inherit'}}>
            <EditCtrl Capt={'Id'} Value={wndData.id} typeVal={'text'} setVal={(d)=>{setValue('id',d)}} width1='42' width2='50' disabled={true}/>
            <div style={{width:'8px',display:'inline-block',flexGrow:4,maxWidth:'16px'}}></div>
            <EditCtrl Capt={localestr('Назва')} Value={wndData.name} typeVal={'text'} setVal={(d)=>{setValue('name',d)}} width1='50' width2='184' />
        </div>
        <div style={{margin:'2px 0',display:'inherit'}}>
        <EditCtrl Capt={localestr('Лише товари з папки')} Value={wndData.goods} typeVal={'fldGoods'} setVal={(d)=>{setValue('goods',d)}} width1='160' width2='174' />
        </div>
        <div className='toolBar no-print'>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Додати')+' (Ins)'} 
            onClick={()=>{setTable({left:10,top:10,width:50,height:50,name:'',active:true})}}
            onKeyUp={(e)=>{if(e.key === 'Enter') {setTable({left:10,top:10,width:50,height:50,name:'',active:true})}}}><img src={icon+'#addBut'} alt={localestr('Додати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Копіювати')+' (F9)'} 
            onClick={copyTable} onKeyUp={(e)=>{if(e.key === 'Enter') copyTable()}}
            ><img src={icon+'#copyBut'} alt={localestr('Копіювати')} /></div>
            <div  tabIndex='0' className='toolBarItem' title={localestr('Видалити')+' (Del)'}
            onClick={()=>{delTable()}}
            onKeyUp={(e)=>{if(e.key === 'Enter') {delTable()}}}><img src={icon+'#delBut'} alt={localestr('Видалити')} /></div>
            <EditCtrl Capt={localestr('Величина сітки')} Value={currSize} typeVal={'number'} setVal={(d)=>{setSize(d)}} width1='110' width2='20' />

            <div  tabIndex='0' className='toolBarItem' title={localestr('Друкувати QR коди')} 
            onClick={()=>prn_req(printTables)} onKeyUp={(e)=>{if(e.key === 'Enter') prn_req(printTables)}}
            ><img src={icon+'#prnBut'} alt={localestr('Друкувати QR коди')} /></div>
            <div style={{flexGrow:'1000'}}></div>
            <div className='toolBarItem' title={localestr('Додатково')}><Menu data={menuData}>
                <img className='toolBarIcon' src={icon+'#dnBut'} alt='' />
            </Menu></div>
        </div>
        <div className='print30' 
            style={{height:'100%',position:'relative',overflow:'auto',backgroundImage:'linear-gradient(#4444 1px, transparent 1px), linear-gradient(90deg, #4444 1px, transparent 1px)',backgroundSize:'20px 20px, 20px 20px'}} 
            onKeyUp={anyKey}>{content}</div>
        <div style={{width:'54px'}} className='key_btn no-print' onClick={()=>{saveValue()}}><div style={{height:'30px',lineHeight:'30px',display:'block'}}>OK</div></div>
    </div>
    )
    
}

export default CatHallsEdit